import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import { VerbRichTextEditor } from '../../../../../shared/components/formComponents/VerbRichTextEditor';
import RichTextNotesHeader from './RichTextNotesHeader';
import CopyAssetLink from '../../../../components/CopyAssetLink';

class UserInviteSectionItem extends Component {
    static propTypes = {
        assetLinkOptions: PropTypes.array,
        memberReference: PropTypes.string,
        isGlobalSectionItem: PropTypes.bool
    };

    render() {
        const { memberReference, isGlobalSectionItem } = this.props;
        return (
            <Fragment>
                <div className={'row'}>
                    <div className={'col-7'}>
                        <Field
                            name={memberReference ? `${memberReference}.content.description` : 'content.description'}
                            label={'Description'}
                            className={'description'}
                            placeholder={'Enter a description'}
                            component={VerbRichTextEditor}
                            readyOnly={isGlobalSectionItem}
                            rows={3}
                        />
                    </div>
                    <div className={'col-5 mt-4'}>
                        <RichTextNotesHeader />
                        <CopyAssetLink assetLinkOptions={this.props.assetLinkOptions} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default UserInviteSectionItem;
